// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------ */

.FindingsPopup_tabs_content_container__OUTF\\+ {
  width: 100%;
}

.FindingsPopup_tab_content__1gwGB {
  width: 100%;
}

.FindingsPopup_finding_container__FOR4t {
  background-color: white;
  width: 100%;
  min-width: 600px;
  margin-bottom: 25px;
  padding: 15px;
  padding-bottom: 2px;
  box-sizing: border-box;
}

.FindingsPopup_finding_action_container__dsvXZ {
  margin-right: 10px;
  margin-bottom: 10px;
}

/* Shared icon styles */
.FindingsPopup_delete_icon_inline__ZkIU2,
.FindingsPopup_delete_icon__kTey4,
.FindingsPopup_edit_icon_inline__k6y9U {
  font-size: 18px !important;
  color: var(--color-theme-lightgray);
  cursor: pointer;
  transition: color 0.2s ease;
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
}

.FindingsPopup_edit_icon_inline__k6y9U {
  vertical-align: middle;
}

.FindingsPopup_delete_icon_inline__ZkIU2:hover,
.FindingsPopup_delete_icon__kTey4:hover {
  color: var(--color-theme-red);
}

.FindingsPopup_delete_icon_disabled__0zoNz,
.FindingsPopup_delete_finding_icon_disabled__uuDr\\+ {
  color: var(--color-theme-deactivated, #ccc) !important;
  cursor: not-allowed;
}

.FindingsPopup_delete_icon_disabled__0zoNz:hover,
.FindingsPopup_delete_finding_icon_disabled__uuDr\\+:hover {
  color: var(--color-theme-deactivated, #ccc) !important;
}

.FindingsPopup_edit_icon_inline__k6y9U:hover {
  color: var(--color-theme-blue);
}

.FindingsPopup_finding_images_container__6nQe9 {
  display: flex;
  justify-content: space-between;
  margin: 0px 10px;
  margin-bottom: 15px;
}

.FindingsPopup_finding_image__A7Q6z {
  height: 195px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
  cursor: pointer;
}

.FindingsPopup_image_container__Pzy9a {
  width: 45%;
  margin-top: 10px;
}

.FindingsPopup_image_wrapper__EUdDn {
  position: relative;
  display: inline-block;
  width: 100%;
}

.FindingsPopup_screenshot_box__9NyIE {
  width: 100%;
}

.FindingsPopup_screenshot_image_wrapper__LOFOZ {
  position: relative;
  width: 100%;
}

.FindingsPopup_screenshot_loading_overlay__i6Dom {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 195px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-theme-darkgray);
  opacity: 0.6;
  z-index: 50;
  border-radius: 2px;
  pointer-events: none;
}

.FindingsPopup_screenshot_edit__xknvU {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
}

.FindingsPopup_edit_icon_overlay__-uP98 {
  color: var(--color-theme-silver);
  background-color: var(--color-theme-snow);
  cursor: pointer;
  padding: 5px;
}

.FindingsPopup_edit_icon_overlay__-uP98:hover {
  color: var(--color-theme-blue);
}

.FindingsPopup_edit_icon_overlay_disabled__IK\\+86 {
  pointer-events: none;
  opacity: 0.5;
}

.FindingsPopup_edit_icon__0OqUs {
  font-size: 16px !important;
  color: var(--color-theme-blue);
}

.FindingsPopup_edit_icon_inline__k6y9U {
  font-size: 18px !important;
  color: var(--color-theme-silver);
  cursor: pointer;
  margin-left: 8px;
  vertical-align: middle;
}

.FindingsPopup_edit_icon_inline__k6y9U:hover {
  color: var(--color-theme-blue);
}

.FindingsPopup_finding_link__cfmuR {
  font-size: 14px;
  text-decoration: underline;
  color: var(--color-theme-blue);
  display: block;
}

.FindingsPopup_image_label__CBAdS {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-font-10, #333);
  margin-bottom: 6px;
}

.FindingsPopup_btn_confirm_small__qpPHs {
  width: auto !important;
  padding: 2px 4px !important;
  font-size: 10px !important;
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.FindingsPopup_finding_info_container__cE08w {
  margin: 0px 10px;
}

.FindingsPopup_info_row__ymj8H {
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
  min-height: 24px;
}

.FindingsPopup_info_label__9-tjP,
.FindingsPopup_info_label_value__Ew8hD {
  font-size: 14px;
  color: var(--color-font-10, #333);
  font-weight: 500;
  padding-right: 10px;
  line-height: 1.5;
  min-width: 90px;
}

.FindingsPopup_info_value_link__Wip-C {
  font-size: 14px;
  color: var(--color-theme-blue);
  text-decoration: none;
  cursor: pointer;
  line-height: 1.5;
  display: inline-block;
  vertical-align: baseline;
}

.FindingsPopup_info_value_link__Wip-C:hover {
  text-decoration: underline;
  color: var(--color-theme-darkblue);
}

.FindingsPopup_info_value__-po1A {
  font-size: 14px;
  color: var(--color-font-10, #333);
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: inline-block;
  max-width: 100%;
  line-height: 1.5;
  vertical-align: baseline;
}

.FindingsPopup_page_link_container__U4HeI {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.FindingsPopup_license_container__ZH-X5 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1;
}

.FindingsPopup_license_row__xNglJ {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
}

.FindingsPopup_license_content__yjBEG {
  flex: 0 1 auto;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.FindingsPopup_license_actions__-6WzT {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
}

.FindingsPopup_license_status__9Ug51 {
  font-size: 14px;
  color: var(--color-font-10, #666);
  white-space: nowrap;
  line-height: 1.5;
}

.FindingsPopup_add_finding_container__NfvoN {
  text-align: right;
  width: 310px;
  background-color: var(--color-bg-caselist);
}

.FindingsPopup_page_link_input_small__wYBbJ .MuiInputBase-input,
.FindingsPopup_page_link_input_small__wYBbJ .MuiOutlinedInput-input,
.FindingsPopup_page_link_input_small__wYBbJ .MuiInputBase-inputMarginDense,
.FindingsPopup_page_link_input_small__wYBbJ .MuiOutlinedInput-inputMarginDense {
  padding: 6px 14px !important;
  font-size: 14px;
  height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/FindingsPopup/FindingsPopup.module.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;;EAGE,0BAA0B;EAC1B,mCAAmC;EACnC,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;;;;EAIE,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB","sourcesContent":["/* ------ */\n\n.tabs_content_container {\n  width: 100%;\n}\n\n.tab_content {\n  width: 100%;\n}\n\n.finding_container {\n  background-color: white;\n  width: 100%;\n  min-width: 600px;\n  margin-bottom: 25px;\n  padding: 15px;\n  padding-bottom: 2px;\n  box-sizing: border-box;\n}\n\n.finding_action_container {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n/* Shared icon styles */\n.delete_icon_inline,\n.delete_icon,\n.edit_icon_inline {\n  font-size: 18px !important;\n  color: var(--color-theme-lightgray);\n  cursor: pointer;\n  transition: color 0.2s ease;\n  display: inline-block;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.edit_icon_inline {\n  vertical-align: middle;\n}\n\n.delete_icon_inline:hover,\n.delete_icon:hover {\n  color: var(--color-theme-red);\n}\n\n.delete_icon_disabled,\n.delete_finding_icon_disabled {\n  color: var(--color-theme-deactivated, #ccc) !important;\n  cursor: not-allowed;\n}\n\n.delete_icon_disabled:hover,\n.delete_finding_icon_disabled:hover {\n  color: var(--color-theme-deactivated, #ccc) !important;\n}\n\n.edit_icon_inline:hover {\n  color: var(--color-theme-blue);\n}\n\n.finding_images_container {\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 10px;\n  margin-bottom: 15px;\n}\n\n.finding_image {\n  height: 195px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.image_container {\n  width: 45%;\n  margin-top: 10px;\n}\n\n.image_wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.screenshot_box {\n  width: 100%;\n}\n\n.screenshot_image_wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.screenshot_loading_overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 195px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-theme-darkgray);\n  opacity: 0.6;\n  z-index: 50;\n  border-radius: 2px;\n  pointer-events: none;\n}\n\n.screenshot_edit {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 100;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.edit_icon_overlay {\n  color: var(--color-theme-silver);\n  background-color: var(--color-theme-snow);\n  cursor: pointer;\n  padding: 5px;\n}\n\n.edit_icon_overlay:hover {\n  color: var(--color-theme-blue);\n}\n\n.edit_icon_overlay_disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.edit_icon {\n  font-size: 16px !important;\n  color: var(--color-theme-blue);\n}\n\n.edit_icon_inline {\n  font-size: 18px !important;\n  color: var(--color-theme-silver);\n  cursor: pointer;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.edit_icon_inline:hover {\n  color: var(--color-theme-blue);\n}\n\n.finding_link {\n  font-size: 14px;\n  text-decoration: underline;\n  color: var(--color-theme-blue);\n  display: block;\n}\n\n.image_label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-font-10, #333);\n  margin-bottom: 6px;\n}\n\n.btn_confirm_small {\n  width: auto !important;\n  padding: 2px 4px !important;\n  font-size: 10px !important;\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.finding_info_container {\n  margin: 0px 10px;\n}\n\n.info_row {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 6px;\n  min-height: 24px;\n}\n\n.info_label,\n.info_label_value {\n  font-size: 14px;\n  color: var(--color-font-10, #333);\n  font-weight: 500;\n  padding-right: 10px;\n  line-height: 1.5;\n  min-width: 90px;\n}\n\n.info_value_link {\n  font-size: 14px;\n  color: var(--color-theme-blue);\n  text-decoration: none;\n  cursor: pointer;\n  line-height: 1.5;\n  display: inline-block;\n  vertical-align: baseline;\n}\n\n.info_value_link:hover {\n  text-decoration: underline;\n  color: var(--color-theme-darkblue);\n}\n\n.info_value {\n  font-size: 14px;\n  color: var(--color-font-10, #333);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  display: inline-block;\n  max-width: 100%;\n  line-height: 1.5;\n  vertical-align: baseline;\n}\n\n.page_link_container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.license_container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n}\n\n.license_row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.license_content {\n  flex: 0 1 auto;\n  min-width: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.license_actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.license_status {\n  font-size: 14px;\n  color: var(--color-font-10, #666);\n  white-space: nowrap;\n  line-height: 1.5;\n}\n\n.add_finding_container {\n  text-align: right;\n  width: 310px;\n  background-color: var(--color-bg-caselist);\n}\n\n.page_link_input_small :global(.MuiInputBase-input),\n.page_link_input_small :global(.MuiOutlinedInput-input),\n.page_link_input_small :global(.MuiInputBase-inputMarginDense),\n.page_link_input_small :global(.MuiOutlinedInput-inputMarginDense) {\n  padding: 6px 14px !important;\n  font-size: 14px;\n  height: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs_content_container": `FindingsPopup_tabs_content_container__OUTF+`,
	"tab_content": `FindingsPopup_tab_content__1gwGB`,
	"finding_container": `FindingsPopup_finding_container__FOR4t`,
	"finding_action_container": `FindingsPopup_finding_action_container__dsvXZ`,
	"delete_icon_inline": `FindingsPopup_delete_icon_inline__ZkIU2`,
	"delete_icon": `FindingsPopup_delete_icon__kTey4`,
	"edit_icon_inline": `FindingsPopup_edit_icon_inline__k6y9U`,
	"delete_icon_disabled": `FindingsPopup_delete_icon_disabled__0zoNz`,
	"delete_finding_icon_disabled": `FindingsPopup_delete_finding_icon_disabled__uuDr+`,
	"finding_images_container": `FindingsPopup_finding_images_container__6nQe9`,
	"finding_image": `FindingsPopup_finding_image__A7Q6z`,
	"image_container": `FindingsPopup_image_container__Pzy9a`,
	"image_wrapper": `FindingsPopup_image_wrapper__EUdDn`,
	"screenshot_box": `FindingsPopup_screenshot_box__9NyIE`,
	"screenshot_image_wrapper": `FindingsPopup_screenshot_image_wrapper__LOFOZ`,
	"screenshot_loading_overlay": `FindingsPopup_screenshot_loading_overlay__i6Dom`,
	"screenshot_edit": `FindingsPopup_screenshot_edit__xknvU`,
	"edit_icon_overlay": `FindingsPopup_edit_icon_overlay__-uP98`,
	"edit_icon_overlay_disabled": `FindingsPopup_edit_icon_overlay_disabled__IK+86`,
	"edit_icon": `FindingsPopup_edit_icon__0OqUs`,
	"finding_link": `FindingsPopup_finding_link__cfmuR`,
	"image_label": `FindingsPopup_image_label__CBAdS`,
	"btn_confirm_small": `FindingsPopup_btn_confirm_small__qpPHs`,
	"finding_info_container": `FindingsPopup_finding_info_container__cE08w`,
	"info_row": `FindingsPopup_info_row__ymj8H`,
	"info_label": `FindingsPopup_info_label__9-tjP`,
	"info_label_value": `FindingsPopup_info_label_value__Ew8hD`,
	"info_value_link": `FindingsPopup_info_value_link__Wip-C`,
	"info_value": `FindingsPopup_info_value__-po1A`,
	"page_link_container": `FindingsPopup_page_link_container__U4HeI`,
	"license_container": `FindingsPopup_license_container__ZH-X5`,
	"license_row": `FindingsPopup_license_row__xNglJ`,
	"license_content": `FindingsPopup_license_content__yjBEG`,
	"license_actions": `FindingsPopup_license_actions__-6WzT`,
	"license_status": `FindingsPopup_license_status__9Ug51`,
	"add_finding_container": `FindingsPopup_add_finding_container__NfvoN`,
	"page_link_input_small": `FindingsPopup_page_link_input_small__wYBbJ`
};
export default ___CSS_LOADER_EXPORT___;
